// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogpostHeroImage_wrapper__t28Ir","blogpostHeroImage":"BlogpostHeroImage_blogpostHeroImage__t5ji8"};